import { atomEffect } from '@exodus/headless-ui';
import { toAssetAtom } from '../atoms/index.js';
const enableTokenEffect = atomEffect((get, set, { exodus, selectors }) => {
    const toAsset = get(toAssetAtom);
    const getIsAssetEnabled = get(selectors.enabledAssets.getIsEnabled);
    if (getIsAssetEnabled(toAsset.name))
        return;
    void exodus.assets.enable([toAsset.name]).catch(() => {
        console.warn('failed to enable token', toAsset);
    });
});
export default enableTokenEffect;
